import React, { lazy } from 'react';
import { IndexRedirect, IndexRoute, Route } from 'react-router';
import PermissionsContainer from 'legacy-src/components/auth/PermissionsContainer';
import PageNotFound from 'legacy/src/components/PageNotFound';
import ValidatedRoute from 'chameleon-src/utility/validatedRoute';

const QuestionBankContainer = lazy(
  () => import('legacy-src/components/questionBank/QuestionBankContainer'),
);
const QuizBuilder = lazy(
  () => import('legacy-src/components/questionBank/QuizBuilder'),
);
const EditItem = lazy(
  () => import('legacy-src/components/questionBank/editor/EditItem/EditItem'),
);
const CreateQuiz = lazy(
  () => import('legacy-src/components/questionBank/CreateQuiz'),
);
const QuizBuilderAutoBuild = lazy(
  () =>
    import(
      'legacy-src/components/questionBank/QuizBuilder/components/QuizBuilderAutoBuild'
    ),
);

const QuizBuilderAutoBuildWrapper = (props) => (
  <QuizBuilder {...props}>
    <QuizBuilderAutoBuild {...props} />
  </QuizBuilder>
);

export default (
  <Route
    name="questionBank"
    path="question_bank"
    component={PermissionsContainer(QuestionBankContainer)}
    leftNav
  >
    <IndexRedirect to="questions" />
    <Route name="allQuestions" path="questions">
      <IndexRoute name="browseQuestions" component={QuizBuilder} />
      <Route
        name="createPreviewItem"
        path="preview/item/:previewId"
        component={ValidatedRoute(QuizBuilder)}
      />
      <Route
        name="createPreviewItem"
        path=":previewId"
        component={ValidatedRoute(QuizBuilder)}
      />
      <Route
        name="createPreviewQuiz"
        path="preview/quiz"
        component={QuizBuilder}
      />
    </Route>

    <Route name="buildQuiz" path="create">
      <IndexRoute name="buildQuiz" component={QuizBuilder} />
      <Route name="createQuizFilters" path="filters" component={QuizBuilder} />
      <Route
        name="createQuizAutoBuildWrapper"
        path="auto-build(/filters)"
        component={QuizBuilderAutoBuildWrapper}
      />
      <Route
        name="unitCreateQuiz"
        path=":unitNumber/unit"
        component={CreateQuiz}
      />
      <Route
        name="bigIdeaCreateQuiz"
        path=":bigIdea/big_idea(/:bigIdeaType)"
        component={CreateQuiz}
      />
      <Route
        name="createNewItem"
        path="item/new/:questionType"
        component={EditItem}
        onLeave={EditItem.willTransitionFrom}
      />
      <Route
        name="createEditItem"
        path="item/:itemId"
        component={EditItem}
        onLeave={EditItem.willTransitionFrom}
      />
      <Route
        name="createPreviewQuiz"
        path="preview/quiz"
        component={QuizBuilder}
      />
    </Route>
    <Route path="*" component={PageNotFound} />
  </Route>
);
